import type { FieldData } from "rc-field-form/es/interface"

export function hasFieldErrors(fields: FieldData[]) {
  return fields.some((field) => !!field?.errors?.length)
}
